import { Link, Outlet } from 'react-router-dom';
import { HaulerCentralHeader } from '../components/HaulerCentralHeader';
import { HaulerCentralLogoIcon } from '../components/HaulerCentralLogo';
import { buildSearchUrl, ROUTES } from '../routes';

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <HaulerCentralHeader />

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t bg-muted/30 text-foreground py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <HaulerCentralLogoIcon className="h-8 w-8 text-primary" />
                <span className="text-lg font-bold text-foreground">HaulerCentral</span>
              </div>
              <p className="text-sm text-muted-foreground">
                The most comprehensive directory of waste haulers and recycling companies in the
                United States.
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-4">For Service Seekers</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>
                  <Link to={ROUTES.SEARCH} className="hover:text-foreground transition-colors">
                    Find Haulers
                  </Link>
                </li>
                <li>
                  <Link
                    to={buildSearchUrl({ service: 'recycling' })}
                    className="hover:text-foreground transition-colors"
                  >
                    Recycling Services
                  </Link>
                </li>
                <li>
                  <Link
                    to={buildSearchUrl({ service: 'hazardous_waste' })}
                    className="hover:text-foreground transition-colors"
                  >
                    Hazardous Waste
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.PRICING} className="hover:text-foreground transition-colors">
                    Area Pricing Guide
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-4">For Haulers</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>
                  <Link
                    to={buildSearchUrl({ claimed_only: 'true' })}
                    className="hover:text-foreground transition-colors"
                  >
                    Claim Your Profile
                  </Link>
                </li>
                <li>
                  <a
                    href="https://commanderai.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-foreground transition-colors"
                  >
                    Commander Platform
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-4">Company</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>
                  <a
                    href="https://commanderai.com/about"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-foreground transition-colors"
                  >
                    About Commander AI
                  </a>
                </li>
                <li>
                  <a
                    href="https://commanderai.com/contact"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-foreground transition-colors"
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t mt-8 pt-8 text-center text-sm text-muted-foreground">
            <p>&copy; {new Date().getFullYear()} Commander AI. All rights reserved.</p>
            <p className="mt-1">
              HaulerCentral is a product of{' '}
              <a
                href="https://commanderai.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                Commander AI
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
